import {
  useGame,
  usePlayer,
  useRound,
  useStage,
} from "@empirica/core/player/classic/react";

import React from "react";
import { Profile } from "./Profile.jsx";
import { Stage } from "./Stage.jsx";
import { useIntegrityTracking } from "./utils/integrityTracking.js";

export function Game() {
  const player = usePlayer();
  const game = useGame();
  const round = useRound();
  const stage = useStage();
  const stageBeginTick = game.get("stageBeginTick");
  const stageName = stage?.get?.("name") || null;
  const isFixedViewportStage = ["discussion", "aiSummary", "assistant"].includes(stageName);
  const isIntegrityTrackingEnabled =
    Boolean(player?.id && stage?.id) &&
    stageName !== "result" &&
    stageName !== "exit";

  useIntegrityTracking({
    enabled: isIntegrityTrackingEnabled,
    player,
    round,
    stage,
    phase: "in-game",
  });

  return (
    <div className="h-full w-full flex min-h-0">
      <div className="h-full w-full flex flex-col min-h-0">
        <Profile />
        <div className={`flex-1 min-h-0 ${isFixedViewportStage ? "overflow-hidden" : "overflow-y-auto"}`}>
          <div
            className={`w-full flex justify-center px-4 ${
              isFixedViewportStage ? "h-full min-h-0 items-stretch py-4" : "items-start pt-4 pb-8"
            }`}
          >
            <div className={isFixedViewportStage ? "w-full min-h-0 flex justify-center" : "w-full flex justify-center"}>
              {/* Force remount on stage/game change to avoid stale submit state and ensure UI advances */}
              <Stage key={`${game?.id || 'g'}-${stage?.id || 's'}-${stageBeginTick || 't'}`} />
            </div>
          </div>
        </div>
      </div>

      {/* Side chat removed for all pages */}
    </div>
  );
}
